/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:41:39
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-04-15 20:35:04
 * @FilePath: \client-h5\src\pages\orderList\services.js
 */
import http from '../../utils/http';

//订单列表
export function getCheckOrderList() {
  return http("get", '/my/order/getdetails');
}


